@if (isLoading) {
  <!-- Skeleton loader while waiting for configuration status -->
  <ng-container>
    <div class="search search--loading">
      <div class="flex flex-col items-center md:flex-row md:items-start gap-4">
        <div class="w-full md:flex-1 flex flex-col gap-2">
          <p-skeleton width="140px" height="1.25rem" />
          <p-skeleton width="100%" height="3rem" borderRadius="0.5rem" />
        </div>

        <div class="md:self-center">
          <p-skeleton
            width="3.5rem"
            height="3.5rem"
            borderRadius="50%"
            styleClass="search__skeleton-swap"
          />
        </div>

        <div class="w-full flex flex-col gap-2">
          <p-skeleton width="140px" height="1.25rem" />
          <p-skeleton width="100%" height="3rem" borderRadius="0.5rem" />
        </div>
      </div>

      <p-skeleton width="100%" height="3rem" borderRadius="2rem" />

      <p-skeleton width="100%" height="3rem" borderRadius="2rem" />
    </div>
  </ng-container>
}

@if (!isLoading && isConfigurationComplete) {
  <!-- Widget funcional cuando la configuración está completa -->
  <ng-container>
    <div class="search">
      <div class="flex flex-col items-center md:flex-row md:items-start gap-4">
        <d2d-input-address
          [locationForm]="origin"
          [id]="'from'"
          [label]="'search_widget.originLabel'"
          [labelColor]="'text-white text-xl font-bold'"
          [showDropdown]="helperDropdownOrigin"
          [fixedCountryCode]="originFixedCountryCode"
          class="w-full md:flex-1"
        />

        <button
          pButton
          class="search__button--swap md:self-center"
          size="large"
          (click)="switchInputsValues()"
        >
          <i class="pi pi-arrow-right-arrow-left rotate-90 md:rotate-0"></i>
        </button>

        <d2d-input-address
          [locationForm]="destination"
          [id]="'to'"
          [label]="'search_widget.destinationLabel'"
          [labelColor]="'text-white text-xl font-bold'"
          [showDropdown]="helperDropdownDestination"
          [fixedCountryCode]="destinationFixedCountryCode"
          [isPrimaryAddressField]="origin.disabled"
          class="w-full md:flex-1"
        />
      </div>

      <div class="search__tripType">
        <button
          type="button"
          role="switch"
          class="search__tripToggle"
          [class.search__tripToggle--roundTrip]="tripType === 'round_trip'"
          [attr.aria-checked]="tripType === 'round_trip'"
          [attr.aria-label]="'search_widget.tripTypeAriaLabel' | transloco"
          (click)="setTripType(tripType === 'round_trip' ? 'one_way' : 'round_trip')"
        >
          <span
            class="search__tripToggleOption"
            [class.search__tripToggleOption--active]="tripType === 'one_way'"
          >
            <i class="pi pi-arrow-right"></i>
            {{ 'search_widget.oneWay' | transloco }}
          </span>
          <span class="search__tripToggleThumb"></span>
          <span
            class="search__tripToggleOption"
            [class.search__tripToggleOption--active]="tripType === 'round_trip'"
          >
            <i class="pi pi-arrow-right-arrow-left"></i>
            {{ 'search_widget.roundTrip' | transloco }}
          </span>
        </button>
        <p class="search__tripToggleDescription">
          {{
            (tripType === 'round_trip'
              ? 'search_widget.roundTripDescription'
              : 'search_widget.oneWayDescription'
            ) | transloco
          }}
        </p>
      </div>

      <button class="search__button" pButton rounded size="large" (click)="goToPurchase()">
        <span>{{ 'search_widget.cta' | transloco }}</span>
      </button>
    </div>
  </ng-container>
}

@if (!isLoading && !isConfigurationComplete) {
  <!-- Mensaje de bloqueo cuando no hay configuración -->
  <ng-container>
    <div class="search search--blocked">
      <div class="search__blocked-message">
        <i class="pi pi-exclamation-triangle"></i>
        @if (hasConfigurationError) {
          <h3>{{ 'search_widget.errorTitle' | transloco }}</h3>
          <p>{{ 'search_widget.errorDescription' | transloco }}</p>
        } @else {
          <h3>{{ 'search_widget.unavailableTitle' | transloco }}</h3>
          <p>{{ 'search_widget.unavailableDescription' | transloco }}</p>
        }
      </div>
    </div>
  </ng-container>
}
